'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlDomain = require('./validateUrlDomain');

var _validateUrlDomain2 = _interopRequireDefault(_validateUrlDomain);

var _validateUrlIp = require('./validateUrlIp');

var _validateUrlIp2 = _interopRequireDefault(_validateUrlIp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateUrlHost = (0, _regexSupplant2.default)('(?:' + '#{validateUrlIp}|' + '#{validateUrlDomain}' + ')', { validateUrlIp: _validateUrlIp2.default, validateUrlDomain: _validateUrlDomain2.default }, 'i'); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validateUrlHost;
module.exports = exports['default'];